import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import {THEME} from '@/site/constants';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {light: THEME},
    options: {
      customProperties: true,
    },
  },
});
